const otherSelectionInputs = document.querySelectorAll('[data-others-item]');

const toggleHiddenItem = (input) => {
  const hiddenItem = input.closest('.input-list__item')?.querySelector('.input-list__item-other');
  hiddenItem?.classList.toggle('hide', !input.checked);
};

// Update all on page load
otherSelectionInputs.forEach(toggleHiddenItem);

// Listen for input changes
otherSelectionInputs.forEach((input) => {
  input.addEventListener('change', () => toggleHiddenItem(input));

  const dropdown = input.closest('[data-component="at-dropdown"]');
  dropdown?.addEventListener('click', () => toggleHiddenItem(input));
});
